'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsonp = require('./jsonp');

var _jsonp2 = _interopRequireDefault(_jsonp);

var _httpRequest = require('./httpRequest');

var _httpRequest2 = _interopRequireDefault(_httpRequest);

var _hooks = require('./utils/hooks');

var _hooks2 = _interopRequireDefault(_hooks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    ajax: function ajax(params) {
        return new _httpRequest2.default().start(params);
    },
    jsonp: function jsonp(url) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return new _jsonp2.default().start(url, params);
    },
    setBeforeSend: function setBeforeSend(cb) {
        _hooks2.default.beforeSend = cb;
    },
    setAfterSend: function setAfterSend(cb) {
        _hooks2.default.afterSend = cb;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/http-request/dist/index.js
// module id = /PpE
// module chunks = 8